module.exports = __webpack_public_path__ + "img/home_lijichadan_hover.903ac25.png";